/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.QuickbooksDesktop {
    'use strict';

    class SyncController {
        private connectionList = [];
        private isAddedToQueue = false;
        private isDeletedFromQueue = false;
        public changeCurrentStep(step: any): any {};
        
        public latestConnectionId: Guid;
        public choosedConection: IConnectionListItem;     

        public messageLastSyncDate: string;
        public messageSyncStatus: string;

        public syncDates: ISyncDate;
        public todayDay = new Date();

        static $inject = [
            'meevo.plugins.quickbooksDesktop.QuickbooksDesktopApi',
            'meevo.components.modal.ModalService',
            'meevo.components.busy.BusyService',
            '$translate',
            '$scope',
            '$q'
        ];

        constructor(
            protected apiService: QuickbooksDesktop.IQuickbooksDesktopApi,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService,
            protected $scope: angular.IScope,
            protected $q: angular.IQService) {
        }

        $onInit(): void {
            this.$scope.$on('selectSyncTab', this.initSyncTab.bind(this));
            this.$scope.$on('resetData', this.resetData.bind(this));   
        }

        /**
         * Initialize Sync Tab after opening
         * @param {any} event
         * @param {any} data from event
         */
        initSyncTab(event: any, data: any): void {
            if (data.latestConnectionId) {
                this.latestConnectionId = data.latestConnectionId;
            }

            /*
            this.syncDates = {
                sync: { from: this.yesterdayDateFotConference, to: this.yesterdayDateFotConference },
                deleteSync: { from: this.yesterdayDateFotConference, to: this.yesterdayDateFotConference }
            };
            */

            this.setDefaultConnectionForDropdown();
            //this.finish();
        }

        submit() {
            if (!this.isChoosedConnection()) return;

            //const requestData = {
            //    id: this.choosedConection.applicationConnectionId,
            //    startDate: this.syncDates.sync.from,
            //    endDate: this.syncDates.sync.to
            //}

            //return this.accountsyncDesktopService.syncData(requestData)
            //    .then(resp => {
            //        this.isAddedToQueue = true;
            //    });  

            //this.modalService.warning(
            //    this.translate.instant("MESSAGE_QUICKBOOKS_DESKTOP_SYNC_WARNING",{ date: 'Sasha' }),
            //    Meevo.Components.Modal.ModalTranslationModes.Translate,
            //    false,
            //    {
            //        showCancelButton: true,
            //        cancelButtonContentKey: 'LABEL_CANCEL',
            //        cancelButtonHotKey: 'MODAL_NO_BUTTON',
            //        okButtonHotKey: 'MODAL_YES_BUTTON',
            //        okButtonContentKey: 'LABEL_OK',
            //    })
            //    .then((response: boolean) => {
            //        if (response) {
            //            // todo add API call
            //            this.modalService.confirm(
            //                "MESSAGE_QUICKBOOKS_DESKTOP_SYNC_CONFIRMATION",
            //                Meevo.Components.Modal.ModalTranslationModes.Translate,
            //                false,
            //                {
            //                    showCancelButton: true,
            //                    cancelButtonContentKey: 'LABEL_OK',
            //                    okButtonContentKey: 'LABEL_GO_TO_QUEUE',
            //                }
            //            ).then((response: boolean) => {
            //                if (response) {
            //                    this.changeCurrentStep({ step: AccountsyncDesktopTabsEnum.Queue });
            //                }
            //            }).catch(e => {
            //                this.isAddedToQueue = true;
            //            })
            //        }
            //    });

            this.validateEditableDates().then(_ => {
                this.busyService.start();
                let drawerSearchCriteria = {
                    criteria: {
                        startDate: moment(this.syncDates.sync.from).subtract(1, 'months').format('l LT'), //day of one month ago
                        endDate: moment(this.syncDates.sync.to).format('l LT')
                    }
                };
                return this.apiService.getNotClosedDrawersList(drawerSearchCriteria);
            }).then(drawersList => {
                if (drawersList.length) {
                    let options: Meevo.Components.Modal.IModalOptions = {
                        templateUrl: 'app/plugins/accountsync/modal/openedDrawersList.modal.html',
                        controller: 'meevo.plugins.accountsync.OpenedDrawerListController',
                        controllerAs: 'vm',
                        clickOutsideToClose: true,
                        locals: { drawersList: drawersList }
                    };
                    this.modalService.showCustom(options);
                    return this.$q.reject();
                }

                const requestData = {
                    id: this.choosedConection.applicationConnectionId,
                    startDate: this.syncDates.sync.from,
                    endDate: this.syncDates.sync.to
                }
                return this.apiService.syncData(requestData);

            }).then(response => {
                this.isAddedToQueue = true;
                //this.currentScreen = SyncScreens.InProcess;
            }).finally(() => {
                this.busyService.stop();
            });
        }

        /**
         * Delete sync using connection id and date range
         */
        deleteSync(): void {
            if (!this.isChoosedConnection()) return;

            const confirmMessage: string = this.translate('MESSAGE_ACCOUNTSYNC_DELETE_ACCOUNTSYNC_DATA_BEGIN') + ' '
                + moment(this.syncDates.deleteSync.from).format('L') + ' ' + this.translate('LABEL_AND') + ' '
                + moment(this.syncDates.deleteSync.to).format('L') + ' ' + this.translate('MESSAGE_ACCOUNTSYNC_DELETE_ACCOUNTSYNC_DATA_END')

                + ' ' + this.translate('MESSAGE_ACCOUNTSYNC_DELETE_ANY_DEPOSITE');
            this.modalService.confirm(confirmMessage)
                .then((response: boolean) => {
                    const requestData = {
                        id: this.choosedConection.applicationConnectionId,
                        startDate: this.syncDates.deleteSync.from,
                        endDate: this.syncDates.deleteSync.to
                    }

                    this.busyService.start();
                    return this.apiService.deleteSync(requestData);
                }).then((response: any) => {
                    this.isDeletedFromQueue = response.syncRequestStatus;
                    //this.currentScreen = SyncScreens.InProcess;
                }).finally(() => {
                    this.busyService.stop();
                });;
        }

        /**
         * Set default connection in dropdown
         */
        private setDefaultConnectionForDropdown(): void {
            if (!this.latestConnectionId) {
                this.latestConnectionId = this.connectionList[0].applicationConnectionId;
            }

            this.chooseConnection(this.latestConnectionId);
        }

        /**
         * Check if selected connection before start sync
         * @returns {boolean}
         */
        private isChoosedConnection(): boolean {
            if (!this.choosedConection) {
                this.modalService.alert(this.translate('MESSAGE_ALERT_PLEASE_CHOOSE_CONNECTION'));
                return false;
            }
            return true;
        }

        /**
         * Validate editable dates before start sync
         * @returns {angular.IPromise<boolean>} promise
         */
        private validateEditableDates(): angular.IPromise<boolean> {
            const monthAgo: Date = moment().subtract(30, 'days').toDate();

            if (this.syncDates.sync.to >= monthAgo) {
                const confirmMessage: string = this.translate('MESSAGE_ACCOUNTSYNC_DATES_ARE_EDITABLE');
                return this.modalService.confirm(confirmMessage);
            }

            return this.$q.resolve(true);
        }

        /**
         * Choose connection by id and get the last sync data of it
         * @param {Guid} applicationConnectionId
         */
        chooseConnection(applicationConnectionId: Guid): void {
            this.apiService.getLastSyncData(applicationConnectionId)
                .then(response => {
                    if (response.processingStatus == undefined) {
                        this.messageLastSyncDate = null;
                        this.messageSyncStatus = null;
                    } else {
                        this.messageLastSyncDate = this.$translate.instant('MESSAGE_LAST_SYNC_DATE',
                            {
                                dateCreated: moment(response.dateCreated).format('L'),
                                dateToProcessFrom: moment(response.dateToProcessFrom).format('L'),
                                dateToProcessTo: moment(response.dateToProcessTo).format('L')
                            });
                    }
                });
        }

        /**
         * Translate using key
         * @param {string} key
         * @returns {string}
         */
        private translate(key: string): string {
            return this.$translate.instant(key);
        }

        /**
         * Functin to clear neccessary data on move out from tab
         * */
        private resetData(): void {
            this.isAddedToQueue = false;
            this.isDeletedFromQueue = false;
        }
    }

    class SyncComponent implements angular.IComponentOptions {
        templateUrl = 'app/plugins/quickbooksDesktop/components/sync/sync.template.html';
        controller = SyncController;
        controllerAs = '$ctrl';
        bindings: any = {
            connectionList: '=',
            changeCurrentStep: '&',
            latestConnectionId: '='
        };
    }

    angular.module('meevo.plugins.quickbooksDesktop')
        .component('quickbooksDesktopSyncComponent', new SyncComponent());
}

